import React from 'react';
import Lottie from 'react-lottie';
import main from '@graphic/main.json';
import classnames from 'classnames/bind';
import styles from './mainKeyVisual.module.scss';
const cx = classnames.bind(styles);

const visual1Options = {
  loop: false,
  autoplay: false,
  animationData: main,
};

const MainKeyVisual = () => {
  return (
    <div className={cx('mainVisual')}>
      <div className={cx('visualWrap')}>
        <Lottie options={visual1Options} />
      </div>
    </div>
  );
};

export default MainKeyVisual;
